import user from '../../Basics/User'
const god = {
  templateName: 'cardTemplateVip28',
  imgSrc: 'card/template/vip00/cardTemplateVip28.png',
  desc: '冰淇凌店',
  category: 'card',
  vipGrade: 0,
  attr: {
    textColor: {
      type: 'color',
      id: '',
      label: '文本颜色',
      value: '#fff'
    },
    bgImage: {
      type: 'image',
      id: '',
      label: '背景图片',
      value: 'card/material/scene10.jpg'
    },
    modelSrc: {
      type: 'model',
      id: '',
      label: '上传模型',
      value: 'model/icecreamshop.gltf'
    }
  }
}
god.attr = Object.assign(god.attr, user)
export default god
